import type { GpuOffer, GpuProvider } from './hooks/useGpuAdmin'

const ATOMICS_PER_USD = 1_000_000
const SECONDS_PER_HOUR = 3600

// Prices are USD atomics (10⁻⁶ USD) per tick of the given length (graph @cloudless/fluence, #2972).
export function usdPerHour(atomics: string, tickSeconds: number): number {
  return (Number(atomics) * SECONDS_PER_HOUR) / tickSeconds / ATOMICS_PER_USD
}

export function formatUsdPerHour(atomics: string, tickSeconds: number) {
  if (!tickSeconds) return '—'
  return `$${usdPerHour(atomics, tickSeconds).toFixed(4)}/h`
}

export function formatUsd(value: string | null | undefined) {
  if (value === null || value === undefined) return '—'
  return `$${Number(value).toFixed(2)}`
}

export function formatHours(value: string | null | undefined) {
  if (value === null || value === undefined) return '—'
  return `${Number(value).toFixed(1)} h`
}

// Runway is null at zero burn — unbounded only when a balance was read.
export function formatRunway(
  hours: string | null | undefined,
  balanceUsd: string | null | undefined,
) {
  if (balanceUsd === null || balanceUsd === undefined) return '—'
  return hours === null || hours === undefined ? '∞' : formatHours(hours)
}

const GIB = 1024 ** 3

export function formatGib(bytes: string) {
  return `${Math.round(Number(bytes) / GIB)} GiB`
}

export function hardwareLabel(hw: GpuOffer['hardware']) {
  const gpu = hw.gpu_count ? `${hw.gpu_count}× ${hw.model} ${hw.vram} GiB` : ''
  const host = `${hw.vcpu} vCPU · ${formatGib(hw.ram_bytes)} RAM · ${formatGib(hw.disk_bytes)} disk`
  return [gpu, host].filter(Boolean).join(' · ')
}

export function formatUsdHourly(price: string | null | undefined) {
  if (!price) return '—'
  return `$${Number(price).toFixed(4)}/h`
}

const SOURCE_LABEL: Record<GpuProvider['markup_source'], string> = {
  provider: 'own',
  database: 'global',
  environment: 'default',
}

export function markupLabel(
  provider: Pick<GpuProvider, 'effective_markup_percent' | 'markup_source'>,
) {
  return `${provider.effective_markup_percent}% (${SOURCE_LABEL[provider.markup_source]})`
}

export function providerName(key: string) {
  return key.charAt(0) + key.slice(1).toLowerCase()
}
